/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_5_Example_CaptionInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_5_example_caption = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_5_Example_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A minimal test record. Replace these example quantities with numbers from your own workbook.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_5_example_caption = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_5_Example_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小测试记录示例，请替换为你自己工作簿中的实际数量。`)
};

/**
* | output |
* | --- |
* | "A minimal test record. Replace these example quantities with numbers from your own workbook." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_5_Example_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_5_example_caption = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_5_Example_CaptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_5_Example_CaptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_5_example_caption(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_5_example_caption(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_5_example_caption as "gc.search_guides.gridcraft_excel_compatibility.sections.5.example.caption" }